import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { httpClient } from '../core';
import { DictionariesModel } from '../models/dictionary.model';
import { env } from '@/env';

export interface DictionariesState {
  dictionaryLanguages: DictionariesModel;
  selectedDictionaryLanguage: string;
  isFetchingDictionaries: boolean;
}

export const state: DictionariesState = {
  dictionaryLanguages: {
    dictionariesByLanguagePair: []
  },
  selectedDictionaryLanguage: '',
  isFetchingDictionaries: false
};

export const getters: GetterTree<DictionariesState, any> = {
  getDictionaryLanguages: () => {
    return state.dictionaryLanguages;
  },
  isFetchingDictionaries: () => {
    return state.isFetchingDictionaries;
  }
};

export const mutations: MutationTree<DictionariesState> = {

  SET_DICTIONARY_LANGUAGES(stateParam, dictionariesParam) {
    stateParam.dictionaryLanguages = dictionariesParam;
    stateParam.isFetchingDictionaries = true;
  },
  SET_FETCHING_DICTIONARIES(stateParam) {
    stateParam.isFetchingDictionaries = true;
  },
  UNSET_FETCHING_DICTIONARIES(stateParam) {
    stateParam.isFetchingDictionaries = false;
  },
  RESET_STATE(stateParam) {
    stateParam.dictionaryLanguages = { dictionariesByLanguagePair: [] };
  }
};

export const actions: ActionTree<DictionariesState, any> = {
  fetchDictionaries: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit('SET_FETCHING_DICTIONARIES');
      httpClient.instance.get(`${env.apiUrl}/dictionaries/${env.applicationId}`)
        .then((dictionariesResponse) => {
          commit('SET_DICTIONARY_LANGUAGES', dictionariesResponse.data);
          resolve(dictionariesResponse);
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.error('Error fetching dictionary ' + error);
          reject(error);
        })
        .finally(() => {
          commit('UNSET_FETCHING_DICTIONARIES');
      });
    });
  },
  resetDictionariesState: ({ commit }) => {
    commit('RESET_STATE');
  }
};

export const dictionaries: Module<DictionariesState, any> = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
